// extracted by mini-css-extract-plugin
module.exports = {"customTabs":"tabs_customTabs__1WwgP"};